var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getRenderedCommunicationChartNodeRadiusPx, isFiniteCommunicationChartPosition } from '@web/components/CommunicationNetworkGraph/graph/communicationChartArrowGeometry';
import { COMMUNICATION_CHART_COLORS, COMMUNICATION_CHART_HUB_SATELLITE_FONT_SIZE_PX } from '@web/components/CommunicationNetworkGraph/graph/communicationChartConstants';
import { resolveCommunicationChartOverlayOpacity } from '@web/components/CommunicationNetworkGraph/graph/communicationChartMotion';
import { resolveCommunicationChartOrgTeamLabelPlacement } from '@web/components/CommunicationNetworkGraph/graph/communicationChartOrgTeamLabelPlacement';
import { isCommunicationChartEmployeeSectionLabelsActive } from '@web/components/CommunicationNetworkGraph/graph/drawCommunicationChartEmployeeSectionLabels';
var ORG_TEAM_LABEL_FONT = '600 12px Inter, ui-sans-serif, system-ui, -apple-system, sans-serif';
var HUB_SATELLITE_LABEL_FONT = "600 ".concat(COMMUNICATION_CHART_HUB_SATELLITE_FONT_SIZE_PX, "px Inter, ui-sans-serif, system-ui, -apple-system, sans-serif");
var HUB_SATELLITE_LABEL_MARGIN_PX = 4;
/** Nodes that show a title on the canvas overlay near the circle (not inside it). */
export var COMMUNICATION_CHART_NEAR_CIRCLE_LABEL_NODE_SELECTOR = '.orgTeam, .external, .teamScopePerson, .teamScopeManagerPerson, .employeeFocusPerson, .crossTeamAggregate';
export var shouldSkipCommunicationChartNearCircleLabel = function (node, cy) {
    if (node.hasClass('hovered') || node.hasClass('hubHidden')) {
        return true;
    }
    if (node.hasClass('external') &&
        cy != null &&
        isCommunicationChartEmployeeSectionLabelsActive(cy)) {
        return true;
    }
    return false;
};
var drawCommunicationChartNearCircleLabel = function (ctx, node, placement) {
    var _a, _b;
    var label = String((_b = (_a = node.data('fullLabel')) !== null && _a !== void 0 ? _a : node.data('label')) !== null && _b !== void 0 ? _b : '').trim();
    if (!label) {
        return;
    }
    var opacity = resolveCommunicationChartOverlayOpacity(node);
    ctx.save();
    ctx.globalAlpha = opacity;
    ctx.fillStyle = node.hasClass('dimmed')
        ? '#94A3B8'
        : COMMUNICATION_CHART_COLORS.label;
    ctx.font = placement.font;
    ctx.textAlign = placement.textAlign;
    ctx.textBaseline = placement.textBaseline;
    ctx.fillText(label, placement.x, placement.y);
    ctx.restore();
};
var drawCommunicationChartHubSatelliteLabels = function (cy, ctx) {
    cy.nodes('.teamHubSatellite').forEach(function (node) {
        if (node.hasClass('hubHidden')) {
            return;
        }
        var center = node.renderedPosition();
        if (!isFiniteCommunicationChartPosition(center)) {
            return;
        }
        var radius = getRenderedCommunicationChartNodeRadiusPx(node);
        drawCommunicationChartNearCircleLabel(ctx, node, {
            x: center.x,
            y: center.y + radius + HUB_SATELLITE_LABEL_MARGIN_PX,
            textAlign: 'center',
            textBaseline: 'top',
            font: HUB_SATELLITE_LABEL_FONT
        });
    });
};
export var drawCommunicationChartOrgTeamLabels = function (cy, ctx) {
    cy.nodes(COMMUNICATION_CHART_NEAR_CIRCLE_LABEL_NODE_SELECTOR).forEach(function (node) {
        if (shouldSkipCommunicationChartNearCircleLabel(node, cy)) {
            return;
        }
        var center = node.renderedPosition();
        if (!isFiniteCommunicationChartPosition(center)) {
            return;
        }
        var placement = resolveCommunicationChartOrgTeamLabelPlacement(node);
        if (!Number.isFinite(placement.x) || !Number.isFinite(placement.y)) {
            return;
        }
        drawCommunicationChartNearCircleLabel(ctx, node, __assign(__assign({}, placement), { font: ORG_TEAM_LABEL_FONT }));
    });
    drawCommunicationChartHubSatelliteLabels(cy, ctx);
};
